import React, { useEffect } from 'react';
import LandingPage from './pages/LandingPage';
import UmamiAnalytics from './components/Umami';

function App() {
    return <>
        <UmamiAnalytics />
        <LandingPage />
    </>
}

export default App;
